var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowRightWhite = function SvgIconArrowRightWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.5 13.305a.667.667 0 0 1 0-.943L9.362 8.5 5.5 4.638a.667.667 0 1 1 .943-.943l3.862 3.862c.52.52.52 1.365 0 1.886l-3.862 3.862a.667.667 0 0 1-.943 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconArrowRightWhite;